
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { MobileRaiseProjection } from "@/store/mobile-raise-templates/types";
import Title from "./Title.vue";
import { Group } from "@/store/eventqueue/types";
import { ManualRaiseResult } from "@/store/manual-raise/types";
import getPosition from "@/services/device.position.service";
import AreaTreeSelect from "@/components/form/AreaTreeSelect.vue";

const ManualRaiseStore = namespace("manualRaise");
const EventQueue = namespace("eventqueue");
@Component({
	components: {
		"raise-title": Title,
		"area-tree-select": AreaTreeSelect
	}
})
export default class RaiseManualRaise extends Vue {
	@Prop() raise: MobileRaiseProjection;
	@EventQueue.Action fetchUserZone: () => Promise<void>;
	@EventQueue.Getter getUserZone: Group;
	@ManualRaiseStore.Action raiseManualAlarm: ({ payload, autoHandle }) => Promise<void>;
	@ManualRaiseStore.Mutation setOnCompleteHandler: (handler: (result: ManualRaiseResult) => void) => void;

	private dataLoaded: boolean = false;
	private createdEventId: number | null = null;
	private selectedGroupId: number = 0;

	async created() {
		this.setOnCompleteHandler(this.onRaiseFinished.bind(this));
		await this.fetchUserZone();
		this.dataLoaded = true;
	}

	beforeDestroy() {
		this.setOnCompleteHandler(null);
	}

	private onRaiseFinished(result: ManualRaiseResult) {
		this.createdEventId = result.eventID;
	}

	private async onConfirm() {
		const pos = await getPosition(2000).catch(error => {
			return { lat: 0, lng: 0 }
		});

		const payload = {
			serverTypeEvent: this.raise.objectID,
			groupID: this.selectedGroupId,
			location: `${pos.lat} ${pos.lng}`
		};

		await this.raiseManualAlarm({ payload, autoHandle: false });
		this.$emit("confirm", this.createdEventId);
	}
}
